var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 95 95",
    width: 95,
    height: 95,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 24,
    height: 26,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAaCAMAAACaYWzBAAAAAXNSR0IB2cksfwAAALdQTFRFAAAA////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////EIqpSQAAAD10Uk5TACeZmxTU/+RaBr0sCJ0R6WMByDOhFvV6BdthBNYp/Kf9hH72OLQa3kXxbKDRO+r7hwv+piLGJGACU9ruadyR+/MAAACaSURBVHicddLJEoJADATQcWt3EQVFEXcFV1BwQ///uyzKA1ZNJ8d+h8wkUapQLJUVqwpQrZG8jqwaTQ1a+FW7IwCMrskB6PUFACxbAAyGDgdgNHY5ABNPAExnHgdgvnA5AEsJLAFWaw6bLW3uB/S5u71D/3Gw6UiOJzrE8/9KcgijC9vHNU7oam937RqMrOfjqeXqlb4/ph5/AVc7EDu1GxnQAAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: none;stroke: #ffffff;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2 } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m45.2 77.4c17.3 0 31.2-13.9 31.2-31.2 0-17.2-13.9-31.2-31.2-31.2-17.2 0-31.2 14-31.2 31.2 0 17.3 14 31.2 31.2 31.2z"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Layer 1",
    href: "#img1",
    x: 36,
    y: 33
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay1);
export default __webpack_public_path__ + "static/media/play1.e109cee1be2ee0b88a1ca1e88822382e.svg";
export { ForwardRef as ReactComponent };